module.exports = __webpack_public_path__ + "static/media/towing_services_s.5f784eeb.png";